var FixtoInit;

(function ($) {

	const selectors = {
		box: '[data-fixto]',
		content: '[data-fixto-content]'
	}


	FixtoInit = class FixtoInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Fixto(el);
			})
		}
	}

	class Fixto {
		constructor(element) {
			this.box = element;
			this.content = $(selectors.content, this.box).get(0);

			if ($(this.content).length) {
				this.init();
			}

			// console.log(this);

		}
		init() {

			const self = this;

			self.offTop = window.scrollOffset ? window.scrollOffset : 0;
			if ($(this.box).attr('data-offset')) this.offTop += parseInt($(this.box).attr('data-offset'));


			self.fixto = fixto.fixTo(this.content, this.box, {
				top: self.offTop,
				useNativeSticky: false
			});
		}
	}

})(jQuery);


export default FixtoInit;